import request from '@/utils/request'

/**
 * 商品列表查询
 * GET /kami/product/list
 */
export function getGoodsList(params) {
  return request({
    url: '/kami/product/list',
    method: 'get',
    params
  })
}

/**
 * 获取商品详情
 * GET /kami/product/getProductDetail/{productNo}
 */
export function getGoodsDetail(productNo) {
  return request({
    url: `/kami/product/getProductDetail/${productNo}`,
    method: 'get'
  })
}

/**
 * 新增商品
 * POST /kami/goods/addGoods
 */
export function addGoods(data) {
  return request({
    url: '/kami/goods/addGoods',
    method: 'post',
    data
  })
}

/**
 * 修改商品
 * POST /kami/product/updateProduct
 */
export function updateGoods(data) {
  return request({
    url: '/kami/product/updateProduct',
    method: 'post',
    data
  })
}

/**
 * 删除商品
 * POST /kami/goods/delGoods
 * body: [id, ...]
 */
export function delGoods(ids) {
  return request({
    url: '/kami/goods/delGoods',
    method: 'post',
    data: ids
  })
}

/**
 * 导出商品
 * POST /kami/product/exportProduct
 * responseType: blob
 */
export function exportGoods(data) {
  return request({
    url: '/kami/product/exportProduct',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
